module.exports = __webpack_public_path__ + "assets/img/2p.57cee171.png";